module.exports = __webpack_public_path__ + "img/0910b_1.68123233.jpg";